/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Currentpage_Openproductpage3Inputs */

const he_extension_popup_currentpage_openproductpage3 = /** @type {(inputs: Extension_Popup_Currentpage_Openproductpage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פתח דף מוצר ב-ksp.co.il כדי לראות אפשרויות`)
};

const en_extension_popup_currentpage_openproductpage3 = /** @type {(inputs: Extension_Popup_Currentpage_Openproductpage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open a ksp.co.il product page to see options`)
};

/**
* | output |
* | --- |
* | "Open a ksp.co.il product page to see options" |
*
* @param {Extension_Popup_Currentpage_Openproductpage3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_currentpage_openproductpage3 = /** @type {((inputs?: Extension_Popup_Currentpage_Openproductpage3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Currentpage_Openproductpage3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_currentpage_openproductpage3(inputs)
	return en_extension_popup_currentpage_openproductpage3(inputs)
});
export { extension_popup_currentpage_openproductpage3 as "extension_popup_currentPage_openProductPage" }